import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const bannerApi = createApi({
  reducerPath: "bannerApi",
  baseQuery: fetchBaseQuery({
    // baseUrl: `http://localhost:8002`,
    baseUrl: `${process.env.REACT_APP_CONTENT_SERVER_BACKEND_URL}`,
    // baseUrl: `${process.env.REACT_APP_BASE_URL}`,
    validateStatus: (response) => {
      if (response.status === 401) {
        window.location.href = "/login";
        return false;
      } else if (response.status >= 200 && response.status < 300) {
        return true;
      } else {
        throw new Error(`HTTP error ${response.status}`);
      }
    },
  }),
  endpoints: (builder) => ({
    GetBanners: builder.mutation({
      query: () => ({
        url: "api/contentServices/content/getBanners",
        method: "POST",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      }),
    }),
    uploadBanner: builder.mutation({
      query: (body) => ({
        url: "api/contentServices/content/insertBanner",
        method: "POST",
        body: body,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      }),
    }),
    updateBanner: builder.mutation({
      query: (body) => ({
        url: `api/contentServices/content/updateBanner`,
        method: "PUT",
        body: body,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      }),
    }),
    deleteBanner: builder.mutation({
      query: (body) => ({
        url: `api/contentServices/content/deleteBanner`,
        method: "POST",
        body: body,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      }),
    }),
  }),
});

export const {
  useGetBannersMutation,
  useUploadBannerMutation,
  useUpdateBannerMutation,
  useDeleteBannerMutation,
} = bannerApi;
